import { RouteRecordRaw } from 'vue-router';
import { CreateTrainingPage } from '@/pages/training';

export const routeName = 'TreinamentosCriar';

export const route: RouteRecordRaw = {
  path: 'treinamentos/criar',
  name: routeName,
  component: CreateTrainingPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Criar Treinamento',
    permissions: [
      { action: 'create', subject: 'Training' },
      { action: 'readMatrix', subject: 'Training' },
    ],
  },
};
